import { Form, Gap, P, Toggle } from '@salecycle/ui-component-library';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  constructPermissionsObject,
  constructPermissionsArray,
  PermissionsObject,
} from './helpers/constructPermissions';
import { useEditRole } from '../context/EditRoleProvider';

function changeAllPermissions(previousPermissions: PermissionsObject, checked: boolean): PermissionsObject {
  const newPermissions = { ...previousPermissions };

  for (const key in newPermissions) {
    newPermissions[key] = checked;
  }

  return newPermissions;
}

function changePermission(
  previousPermissions: PermissionsObject,
  permission: string,
  isOn: boolean,
): PermissionsObject {
  return {
    ...previousPermissions,
    [permission]: isOn,
  };
}

export const EditRoleSidebar: React.FC = () => {
  const { t } = useTranslation();
  const { rolePermissions, setRolePermissions } = useEditRole();
  const permissionsObject = constructPermissionsObject(rolePermissions);
  const permissionToggles: Array<{ name: string; isSelected: boolean }> = [];
  const allPermissionsActive = Object.values(permissionsObject).every(val => !!val);
  const changeSelection = (name: string, checked: boolean) =>
    setRolePermissions(constructPermissionsArray(changePermission(permissionsObject, name, checked)));
  const toggleAllPermissions = (checked: boolean) =>
    setRolePermissions(constructPermissionsArray(changeAllPermissions(permissionsObject, checked)));

  for (const key in permissionsObject) {
    permissionToggles.push({
      name: key,
      isSelected: permissionsObject[key],
    });
  }

  return (
    <>
      <P>{t('userManagement.roles.edit.sidebar.description')}</P>
      <Gap top={30} />

      <Form>
        <Toggle
          label={t('userManagement.roles.edit.sidebar.selectAllToggle.label')}
          ariaLabel={t('userManagement.roles.edit.sidebar.selectAllToggle.ariaLabel')}
          onChange={toggleAllPermissions}
          checked={allPermissionsActive}
        />

        {permissionToggles
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map(option => (
            <Fragment key={`${option.name}-toggle`}>
              <Gap top={15} />
              <Toggle
                label={t(`userManagement.roles.edit.sidebar.permissionsLabels.${option.name}`)}
                checked={option.isSelected}
                ariaLabel={t(`userManagement.roles.edit.sidebar.permissionsLabelsAriaLabels.${option.name}`, {
                  optionName: option.name,
                })}
                onChange={isOn => changeSelection(option.name, isOn)}
                margin={false}
              />
            </Fragment>
          ))}
      </Form>
    </>
  );
};
